import { Grid, Typography } from '@mui/material';
import React from 'react';

interface Props {
    offer: any;
}

const PositionPartial = ({offer}: Props) => {

    return (
        <Grid container rowSpacing={2} columns={{ xs: 4 }} sx={{p: '1rem 1.5rem'}}>
            <Grid item xs={1}><Typography variant="h5">Type de mission</Typography></Grid>
            <Grid item xs={3}>{offer.job_contract}</Grid>
            <Grid item xs={1}><Typography variant="h5">Type de contrat</Typography></Grid>
            <Grid item xs={3}>{offer.job_type}</Grid>
            <Grid item xs={1}><Typography variant="h5">Secteur d'activité</Typography></Grid>
            <Grid item xs={3}>{offer.job_industry}</Grid>
            <Grid item xs={1}><Typography variant="h5">Localisation</Typography></Grid>
            <Grid item xs={3}>{offer.address?.address}</Grid>
            <Grid item xs={1}><Typography variant="h5">Description du poste</Typography></Grid>
            <Grid item xs={3}>{offer.job_description}</Grid>
            <Grid item xs={1}><Typography variant="h5">Périodicité</Typography></Grid>
            <Grid item xs={3}>{offer.salary_cadence}</Grid>
            <Grid item xs={1}><Typography variant="h5">Minimum</Typography></Grid>
            <Grid item xs={3}>{offer.salary_from}</Grid>
            <Grid item xs={1}><Typography variant="h5">Maximum</Typography></Grid>
            <Grid item xs={3}>{offer.salary_to}</Grid>
            <Grid item xs={1}><Typography variant="h5">Devise</Typography></Grid>
            <Grid item xs={3}>Euro (€)</Grid>
            <Grid item xs={1}><Typography variant="h5">Avantages</Typography></Grid>
            <Grid item xs={3}>{offer.salary_benefits}</Grid>
        </Grid>
    );
};

export { PositionPartial };
